module Meevo.Plugins.OnlineBookingSettings {
    "use strict";

    export class MeevoBusinessTypeDropDown {
        restrict = "E";

        scope = {
            currentValue: "=ngModel",
            //businessTypes: "=",
            ngChange: "&",
            baseEndpoint: "@",
            ngDisabled: "&"
        };

        require = "ngModel";

        templateUrl = "app/plugins/onlineBookingSettings/directives/businessTypeDropDownTemplate.html";

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {

            scope.sort = { sortBy: null, sortDirection: Model.SortDirection.Descending };
            scope.criteria = {};

            function buildRequest<T, TSearch extends Model.SearchCriteria>(): Model.SearchPage<T, TSearch> {

                let request = <Model.SearchPage<T, TSearch>>{
                    pageNumber: 0,
                    itemsPerPage: 25,
                    criteria: scope.criteria,
                    sortBy: scope.sort.sortBy,
                    sortDirection: scope.sort.sortDirection

                }

                return request;
            }

            this.dataService.getListPaged(scope.baseEndpoint, buildRequest()).then((results:any) => {
                scope.businessTypes = results;
                scope.currentValue = results[0].id;
            });
 
        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService) {
            
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoBusinessTypeDropDown(dataService);
            }
            
            directive.$inject = ["meevo.components.common.DataService"];
            return directive;
        }
    }

    angular.module("meevo.plugins.onlineBookingSettings")
        .directive("businessTypeDropDown", MeevoBusinessTypeDropDown.factory());
}